import { gql } from 'graphql-request';

export const CACHE_INVOICE_PAY_INTERNAL_QUERY = gql`
  mutation CacheInvoicePayInternal(
    $uuid: ID!
    $paymentMethod: String!
    $accountId: ID
    $fileAttachmentId: ID
  ) {
    invoicePayInternal(
      input: {
        uuid: $uuid
        paymentMethod: $paymentMethod
        accountId: $accountId
        fileAttachmentId: $fileAttachmentId
      }
    ) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        nanoId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
